import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import firebaseApp from "../firebaseApp";

const CurrentUserContext = createContext();

const CurrentUserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  useEffect(() => {
    const auth = getAuth(firebaseApp);
    let unregister = onAuthStateChanged(
      auth,
      (user) => {
        console.log("user", user);
        setCurrentUser(user);
        //localStorage.setItem('authUser', JSON.stringify(user));
      },
      () => {
        localStorage.removeItem("authUser");
        setCurrentUser(null);
      }
      //setCurrentUser(JSON.parse(localStorage.getItem('authUser'))),
    );
    return () => {
      unregister();
    };
  }, []);
  const value = useMemo(
    () => [currentUser, setCurrentUser],
    [currentUser, setCurrentUser]
  );

  return (
    <CurrentUserContext.Provider value={value}>
      {children}
    </CurrentUserContext.Provider>
  );
};
export { CurrentUserProvider };

const useCurrentUser = () => useContext(CurrentUserContext);
export default useCurrentUser;
